<template>
  <div>
    <div class="col-12" style="display: flex; align-items: center">
      <router-link class="btn btn-info m-2" :to="`/dashboard/ptsp-terminals`">
        Back to Terminals
      </router-link>

      <button
        class="btn btn-info mr-2"
        @click="doDisable"
        v-if="terminal.disabled === false"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Disable Terminal
      </button>
      <button
        class="btn btn-info m-2"
        @click="doEnable"
        v-if="terminal.disabled === true"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Enable Terminal
      </button>
      <button
        class="btn btn-info m-2"
        @click="doDelete"
        :style="{ display: isInstitution ? 'none' : 'block' }"
      >
        Delete Terminal
      </button>

      <button
        v-if="terminal.agentId !== null"
        class="btn btn-info m-2"
        @click="toggleReasonsForm"
        :style="{ display: isInstitution ? 'none' : 'block' }"
        id="reason"
      >
        {{ showReasonsForm ? "Close" : "Unlink Device" }}
      </button>
    </div>

    <card class="card" :title="`Terminal ${terminal.terminalId}`">
      <div>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id"
                placeholder="Terminal Id"
                v-model="terminal.terminalId"
                aria-required="true"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Serial Number"
                :disabed="true"
                placeholder="Serial Number"
                v-model="terminal.serialNo"
                aria-required="true"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Merchant Id"
                placeholder="Merchant Id"
                v-model="terminal.merchantId"
                aria-required="true"
              >
              </fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id 1"
                placeholder="Terminal Id 1"
                v-model="terminal.terminalId1"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Terminal Id 2"
                placeholder="Terminal Id 2"
                v-model="terminal.terminalId2"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <label>Terminal Type</label>
              <multiselect
                v-model="terminal.terminalType"
                label="label"
                track-by="key"
                :options="terminalTypes"
                :allow-empty="false"
                placeholder="Select a Terminal Type"
                aria-required="true"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.label }}
                </template>
              </multiselect>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <label>Institution Name</label>

              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.institutionId"
                @change="getMerchants"
                required
              >
                <option value="">Select Institution</option>
                <option
                  v-for="institution in allInstitutions"
                  :key="institution._id"
                  :value="institution._id"
                >
                  {{ institution.institutionName }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Merchant Name</label>

              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.tmsMerchantId"
                required
              >
                <option value="">Select Merchant</option>
                <option
                  v-for="merchant in institutionMerchants"
                  :key="merchant._id"
                  :value="merchant._id"
                >
                  {{ merchant.merchantName }}
                </option>

                <option v-if="!institutionMerchants.length" disabled>
                  No merchants found under this institution
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Sales Officer </label>

              <v-select
                v-model="terminal.salesOfficerId"
                :options="formattedSalesOfficers"
                :reduce="(officer) => officer._id"
                label="fullName"
                placeholder="Select Sales Officer"
                searchable
                style="border: none"
                aria-required="true"
              />
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-md-4">
              <label>Country</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.country"
                required
                @change="getStates()"
              >
                <option value="">country</option>
                <option
                  v-for="(ct, index) in utils.countries"
                  :key="index"
                  :value="ct.code"
                >
                  {{ ct.name }}
                </option>
              </select> -->
            <!-- </div> -->

            <div class="col-md-4">
              <label>State</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.state"
                required
                @change="fetchLgas()"
              >
                <option value="">State</option>
                <option v-for="st in utils.allStates" :key="st" :value="st">
                  {{ st }}
                </option>
              </select>
            </div>

            <div class="col-md-4">
              <label>Local Government</label>
              <select
                class="form-control op-border"
                id="rate-type"
                v-model="terminal.localGovernment"
                required
              >
                <option value="">Select Local Government</option>
                <option v-for="lg in utils.lgas" :key="lg.id" :value="lg.name">
                  {{ lg.name }}
                </option>
              </select>
              <span v-if="utils.lgaLoading"> Fetching Lga's </span>
            </div>
          </div>

          <h4 :style="{ display: isInstitution ? 'none' : 'block' }">
            Configuration Panel
          </h4>

          <div
            class="p-4"
            :style="{ display: isInstitution ? 'none' : 'block' }"
          >
            <div class="row">
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  v-model="terminal.forceConfig"
                  class="form-check-input"
                  id="exampleCheck1"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Force Configure Terminal</label
                >
              </div>
            </div>

            <div class="row">
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  v-model="terminal.forceUpgrade"
                  class="form-check-input"
                  id="exampleCheck1"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Force Upgrade Terminal</label
                >
              </div>
            </div>

            <div class="row">
              <div class="form-group form-check">
                <input
                  type="checkbox"
                  v-model="terminal.deviceLog"
                  class="form-check-input"
                />
                <label class="form-check-label" for="exampleCheck1"
                  >Enable Device Log</label
                >
              </div>
            </div>
          </div>

          <div
            class="text-center"
            :style="{ display: isInstitution ? 'none' : 'block' }"
          >
            <p-button type="info" round @click.native.prevent="submit">
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Update Terminal
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {
    Multiselect,
    vSelect,
  },
  data() {
    return {
      showReasonsForm: false,
      userType: localStorage.getItem("userType"),
      allSalesOfficers: [],
      allInstitutions: [],
      institutionMerchants: [],
      terminal: {
        terminalId: "",
        walletId: "",
        serialNo: "",
        merchantId: "",
        agentId: "",
        tmsMerchantName: "",
        institutionId: "",
        agentName: "",
        terminalId1: "",
        terminalId2: "",
        appVersion: "",
        currentVersion: "",
        country: "",
        state: "",
        terminalType: null,
        forceConfig: false,
        forceUpgrade: false,
        deviceLog: false,
      },
      selectedMerchant: "",
      selectedAgent: "",
      link: {
        id: "",
        reason: "",
      },

      terminalTypes: [
        { label: "T3 POS", key: "T3 POS" },
        { label: "CARD READER", key: "CARD READER" },
        { label: "MPOS", key: "MPOS" },
      ],
      selectedInstitutionId: "",
    };
  },

  computed: {
    ...mapState(["auth", "loading", "utils"]),
    isInstitution() {
      return this.userType === "INSTITUTIONS";
      // return this.userType === 'super-admin';
    },
    formattedSalesOfficers() {
      return this.allSalesOfficers.map((o) => ({
        ...o,
        fullName: `${o.firstName} ${o.lastName || ""}`.trim(),
      }));
    },
  },

  methods: {
    ...mapActions([
      "updateTerminal",
      "getStates",
      "getLgas",
      "getCountries",
      "setLoading",
      "disableTerminal",
      "enableTerminal",
      "deleteTerminal",
      "setNotification",
      "getAllMerchantAgents",
      "getMerchants",
    ]),

    async getTerminal() {
      try {
        this.setLoading(true);
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/terminal/${this.$route.params.terminalId}`,
        );
        const { terminal } = res.data;
        // this.terminal = terminal;

        // if (terminal.terminalType) {
        //   this.terminal.terminalType = this.terminalTypes.find(
        //     (t) => t.key === this.terminal.terminalType
        //   );
        // } else {
        //   this.terminal.terminalType = null;
        // }

        this.terminal = {
          ...this.terminal,
          ...terminal,
          terminalType: terminal.terminalType
            ? this.terminalTypes.find((t) => t.key === terminal.terminalType)
            : null,
        };

        this.getLgas(this.terminal.state);
        this.setLoading(false);
      } catch (error) {
        if (error.response && error.response.data) {
          const { message } = error.response.data;
          this.setNotification({ type: "danger", message });
        } else {
          this.setNotification({
            type: "danger",
            message: "Unable to Fetch Terminal",
          });
        }
      }
    },

    doDisable() {
      this.$confirm("Disable Terminal! Are you sure?").then(() => {
        this.disableTerminal({ id: this.terminal._id });
        this.getTerminal();
      });
    },
    doEnable() {
      this.$confirm("Enable Terminal?").then(() => {
        this.enableTerminal({ id: this.terminal._id });
        this.getTerminal();
      });
    },
    doDelete() {
      this.$confirm("Delete Terminal?").then(() => {
        this.deleteTerminal({ id: this.terminal._id });
        router.push("/dashboard/ptsp-terminals");
        this.getTerminal();
      });
    },

    toggleReasonsForm() {
      this.showReasonsForm = !this.showReasonsForm;
    },

    addReason() {
      this.$confirm("Unlink Device?").then(async () => {
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/agent/unlink`,
            { id: this.terminal._id, reason: this.link.reason },
          );
          const { message } = res.data;

          this.setNotification({
            type: "success",
            message,
          });
          window.location.reload();
          this.showReasonsForm = false;
        } catch (err) {
          const { message } = err.response.data;

          this.setNotification({
            type: "danger",
            message,
          });
          this.showReasonsForm = false;
        }
      });
    },

    getAgents() {
      this.getAllMerchantAgents({ merchantId: this.selectedMerchant._id });
    },

    optionLabel({ merchantName, state, country }) {
      return `${merchantName}, ${state}, ${country}`;
    },

    optionLabel2({ firstName, lastName, walletId }) {
      return `${firstName}, ${lastName}, ${walletId}`;
    },

    fetchLgas() {
      this.terminal.lga = "";
      this.getLgas(this.terminal.state);
    },

    async getSalesOfficers() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/external-request/user/get-all-users`,
        );
        this.allSalesOfficers = res.data.users;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Sales Officers",
          });
        }
      }
    },

    async getInstitutions() {
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/get-institution-list`,
        );
        console.log(res.data.institutions);

        const institutions = res.data.institutions;
        this.allInstitutions = institutions;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    async getMerchants() {
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/institution/${this.terminal.institutionId}/merchants`,
        );

        this.institutionMerchants = res.data.data;
      } catch (err) {
        const { data } = err.response.data;
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch All Merchants",
          });
        }
      }
    },

    isValid(values) {
      let missingFields = [];
      if (!values.terminalId) {
        missingFields.push("Terminal Id");
      }

      if (!values.serialNo) {
        missingFields.push("Serial Number");
      }

      if (!values.merchantId) {
        missingFields.push("Merchant Id");
      }

      if (!values.terminalType) {
        missingFields.push("Terminal Type");
      }
      if (!values.institutionId) {
        missingFields.push("Institution");
      }
      if (!values.tmsMerchantId) {
        missingFields.push("Merchant Name");
      }

      if (!values.state) {
        missingFields.push("State");
      }
      if (!values.localGovernment) {
        missingFields.push("Local Government");
      }

      if (missingFields.length > 0) {
        this.$toast.error(
          `Please fill in all the following fields: ${missingFields.join(
            ", ",
          )}`,
        );
        return false;
      }

      return true;
    },

    submit() {
      if (!this.isValid(this.terminal)) return;
      this.$confirm("Confirm Updated Details?").then(() => {
        const payload = { ...this.terminal };

        payload.terminalType = payload.terminalType.key;

        if (payload.institution) {
          payload.institution = {
            _id: payload.institution._id,
            name: payload.institution.institutionName,
          };
        }

        // if (this.terminal.tmsMerchantId !== "") {
        //   payload.tmsMerchantId = this.terminal.tmsMerchantId;
        // }
        // if (this.terminal.institution._id !== "") {
        //   this.terminal.institution._id = this.terminal.institution._id;
        // }

        this.updateTerminal(payload);
      });
    },
  },

  async mounted() {
    await this.getTerminal();
    this.getMerchants();
    this.getSalesOfficers();
    this.getInstitutions();
    this.getStates();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
